import { SnackbarProvider as SnackbarProviderNotistack } from 'notistack';
import React from 'react';
import { isMobile } from 'react-device-detect';
import Snackbar from 'ui/molecules/Snackbar/Snackbar';

const SnackbarProvider: React.FC<React.PropsWithChildren> = (props) => {
  const { children } = props;
  return (
    <SnackbarProviderNotistack
      {...props}
      maxSnack={1}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      content={(key, message) => <Snackbar id={`${key}`} message={message as string} isMobile={isMobile} />}
    >
      {children}
    </SnackbarProviderNotistack>
  );
};
export default SnackbarProvider;
